export class EnumHelper<T extends Record<string, string>> {
  private labels: T;

  constructor(labels: T) {
    this.labels = labels;
  }

  getLabel(key: keyof T | string): string {
    return this.labels[key as keyof T] ?? String(key);
  }

  getOptions(): { value: keyof T; label: string }[] {
    return Object.entries(this.labels).map(([value, label]) => ({
      value: value as keyof T,
      label,
    }));
  }

  getKeys(): (keyof T)[] {
    return Object.keys(this.labels) as (keyof T)[];
  }

  getValues(): string[] {
    return Object.values(this.labels);
  }
}
